import type { PaginationProps } from "antd";
import { Pagination } from "antd";
import React from "react";

const NetwalaPagination: React.FC<NetwalaPagination> = ({
  pagination,
  handlePageSwitch,
  handlePageSizeChange,
}) => {
  const onChange: PaginationProps["onChange"] = (page) => {
    handlePageSwitch(page);
  };

  const onShowSizeChange: PaginationProps["onShowSizeChange"] = (current, size) => {
    if (handlePageSizeChange) {
      handlePageSizeChange(current, size);
    }
  };

  return (
    <Pagination
      current={pagination.currentPage}
      onChange={onChange}
      total={pagination.totalCount}
      showSizeChanger={true}
      pageSize={pagination.pageSize}
      onShowSizeChange={onShowSizeChange}
      pageSizeOptions={["10", "20", "50", "100", "200"]}
    />
  );
};

export default NetwalaPagination;
